import * as React from "react";

const data = {
  planProgressId: "",
  setPlanProgressId: (id: string) => {},
};

export const LibraryContext = React.createContext(data);
